import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import getIsCoppa from "../../store/coppa";

const CoppaStrategy = ({ coppaComponent, nonCoppaComponent, ...rest }) => {
  const isCoppa = useSelector(getIsCoppa);
  const ComponentToRender = isCoppa ? coppaComponent : nonCoppaComponent;
  return <ComponentToRender {...rest} />;
};

CoppaStrategy.propTypes = {
  coppaComponent: PropTypes.elementType.isRequired,
  nonCoppaComponent: PropTypes.elementType.isRequired
};

export default CoppaStrategy;
